<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-date-picker
          v-model="table.query.startYear"
          type="year"
          placeholder="请选择年份"
          @change="getSettlementResult()"
          value-format="yyyy"
        >
        </el-date-picker>
        <div class="title mt20">收入统计</div>
        <div class="lr start" v-if="showSettlement">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span class="card-title">总收：{{settlement[0].totalReceive}}</span>
            </div>
            <div class="text item">
              <span class="mr20" v-for="(member,index) in settlement[0].receiveMembers" :key="index">{{member.name}}：{{member.value}}</span>
            </div>
          </el-card>
          <el-card class="box-card ml20" shadow="hover">
            <div slot="header" class="clearfix">
              <span class="card-title">总盈利：{{settlement[1].totalProfit}}</span>
              <span class="des">（盈利 = 收租 + 违约金 - 房东总交 - 中介费 - 空置亏损 - 退款房租）</span>
              <span class="des">（空置亏损 ＝ 房间成本价 * 房源的n个房间年总空置总和）</span>
              <span class="des">（房间成本价 ＝ 房源月租金 ÷ 30 ÷ 房源房间数）</span>
            </div>
            <div class="text item">
              <span class="mr20">违约金：{{settlement[1].totalBreak}}</span>
              <span class="mr20">房东总交：{{settlement[1].totalOwnerCollect}}</span>
              <span>中介费：{{settlement[1].totalAgency}}</span>
            </div>
          </el-card>
        </div>
        <div class="title mt20">房间明细</div>
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
          </div>
        </div>
        <div class="main">
          <el-table :data="table.data" height="600px" border :span-method="objectSpanMethod"
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="房间" align="center"
                             prop="roomName"></el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="adminName"></el-table-column>
            <el-table-column show-overflow-tooltip label="租金" align="center"
                             prop="rent"></el-table-column>
            <el-table-column show-overflow-tooltip label="状态" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 0">未收租</span>
                <span v-if="scope.row.state == 1">已收租</span>
                <span v-if="scope.row.state == 2">退租</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="应收租日期" align="center"
                             prop="needRentDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="实际收租日期" align="center"
                             prop="actualRentDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
              <template slot-scope="scope">
                <el-button type="text" :loading="confirmLoading" @click="confirmRecord(scope.row, 1)" v-if="scope.row.state == 0" :disabled="scope.row.adminId != userInfo.id">交租</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {getPageList, confirmRecord} from "@/api/collectRecord";
import {settlement} from "@/api/house";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          startYear: ''
        },
        total: 0,
        data: []
      },
      confirmLoading: false,
      tableLoading: false,
      userInfo: {},
      mergeObj: {},
      mergeArr: ['roomName', 'adminName'],
      settlement: [],
      showSettlement: false,
      houseId: 0,
      actualMonth: []
    }
  },
  mounted() {
    this.table.query.startYear = new Date().getFullYear() + ''
    this.search(true)
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.houseId = this.$route.query.houseId
  },
  methods: {
    getSettlementResult() {
      const params = {
        houseId: this.houseId,
        startYear: this.table.query.startYear
      }
      settlement(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.settlement = response.data
          this.showSettlement = true
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.houseId = this.houseId
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        startYear: this.table.query.startYear,
        houseId: this.houseId
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
          this.getSpanArr(this.table.data)
          this.getSettlementResult()
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    confirmRecord(data, state) {
      this.confirmLoading = true
      this.$confirm('您是否确认收租?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data.state = state
        confirmRecord(data).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error('操作失败!')
          }
          this.confirmLoading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消收租'
        })
      })
    },
    getSpanArr(data) {
      this.mergeArr.forEach((key, index1) => {
        let count = 0; // 用来记录需要合并行的起始位置
        this.mergeObj[key] = []; // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if(index === 0) {
            this.mergeObj[key].push(1);
          } else {
            // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
            if(item[key] === data[index - 1][key]) {
              this.mergeObj[key][count] += 1;
              this.mergeObj[key].push(0);
            } else {
              // 如果当前行和上一行其值不相等
              count = index; // 记录当前位置
              this.mergeObj[key].push(1); // 重新push 一个 1
            }
          }
        })
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 判断列的属性
      if(this.mergeArr.indexOf(column.property) !== -1) {
        // 判断其值是不是为0
        if(this.mergeObj[column.property][rowIndex]) {
          return [this.mergeObj[column.property][rowIndex], 1]
        } else {
          // 如果为0则为需要合并的行
          return [0, 0];
        }
      }
    }
  }
}
</script>

<style scoped>
.card-title {
  font-weight: bolder;
}

.des {
  color: red;
}

.el-card__header {
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/views/back/settlement.vue